import { IonChip, IonText } from '@ionic/react';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';

const DEFAULT_GROUPS_COUNT = 3;

const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const ChipWrapText = styled(IonText)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const ChipsGroup = ({ labels, onShowAll }: { labels: string[]; onShowAll?: () => void }) => {
  const groupsWithIds = useMemo(
    () => labels.map(label => ({ id: Math.random(), name: label })),
    [labels]
  );
  const [showAllGroups, setShowAllGroups] = useState(false);

  const wrapChipText = !showAllGroups && groupsWithIds.length > DEFAULT_GROUPS_COUNT;
  const groupsToShow = wrapChipText ? groupsWithIds.slice(0, DEFAULT_GROUPS_COUNT) : groupsWithIds;

  const handleShowAll = () => {
    setShowAllGroups(true);
    onShowAll?.();
  };

  return (
    <ChipsContainer>
      {groupsToShow.map(({ id, name }) => (
        <IonChip data-testid="group" key={id}>
          {wrapChipText && <ChipWrapText>{name}</ChipWrapText>}
          {!wrapChipText && name}
        </IonChip>
      ))}
      {!showAllGroups && groupsWithIds.length > DEFAULT_GROUPS_COUNT && (
        <IonChip
          // skipcq: JS-0417
          onClick={handleShowAll}
        >
          +{groupsWithIds.length - DEFAULT_GROUPS_COUNT}
        </IonChip>
      )}
    </ChipsContainer>
  );
};

export default ChipsGroup;
